import React from 'react'
import PropTypes from 'prop-types'

import { Like, Paper, Leaf } from './Svg'

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  decrementQuantity() {
    const { elm, change } = this.props
    var quantity = elm?.quantity - 1
    change( elm?.id, quantity > 0 ? quantity : 0 )
  }

  incrementQuantity() {
    const { elm, change } = this.props
    var quantity = elm?.quantity + 1
    change( elm?.id, quantity < 99 ? quantity : 99 )
  }

  render() {
    const { elm, k } = this.props

    return (
      <div key={k} className='mb-[15px] leading-[100%] relative'>
        <div className='w-[100%] bg-white rounded-[25px] flex gap-[10px]'>
          {elm?.image != '' &&
            <div className='flex-none relative'>
              <img 
                className='w-[101px] h-[auto]' 
                src={elm?.image} 
                alt={elm?.pagetitle} 
                width="101" 
                height="64" 
              />
            </div>
          }
          <div className='flex-1'>
            <div className='text-black text-[18px] font-medium mb-[5px]'>
              {elm?.pagetitle}
            </div>
            <div className='flex items-center w-[100%] gap-[10px]'>
              <div className='flex rounded-[35px] bg-[#F6F6F6] h-[35px] w-[126px] items-center justify-between p-[5px]'>
                <button 
                  onClick={() => this.decrementQuantity()}
                  className="w-[20px] h-[30px] flex items-center justify-center"
                  disabled={elm?.quantity <= 0}
                >
                  <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path 
                      d="M1 1L11.5 1" 
                      stroke={elm?.quantity <= 0 ? "#C9C9C9" : "black"} 
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
                <div className='text-[16px] font-normal text-center'>
                  {elm?.quantity + elm?.pcount} шт
                </div>
                <button 
                  onClick={() => this.incrementQuantity()}
                  className="w-[20px] h-[30px] flex items-center justify-center"
                >
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.24512 1V11.5" stroke="black" strokeLinecap="round"/>
                    <path d="M1 6.25488L11.5 6.25488" stroke="black" strokeLinecap="round"/>
                  </svg>
                </button>
              </div>
              <div className='text-black text-[16px] font-medium whitespace-nowrap'>{elm?.total} ₽</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Main.propTypes = {
  elm: PropTypes.object,
  k: PropTypes.number,
  change: PropTypes.func
}

export default Main